export const toTitleCase = (value: string): string => {
  return value
    .split(' ')
    .map((word) =>
      word
        ? `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`
        : word
    )
    .join(' ')
}